import moment from 'moment-timezone';

import { DATE_DAILY_FORMAT, FULL_DATE_FORMAT, MS_FORMAT } from '../../constants/date';
import createDateRange from '../date';
import { DEFAULT_DATA } from '../../constants/common';

export function binarySearch(arr, compareFn) {
  let start = 0;
  let end = arr.length - 1;

  while (start <= end) {
    const mid = Math.floor((start + end) / 2);
    if (compareFn(arr[mid]) === 0) {
      return arr[mid];
    }
    if (compareFn(arr[mid]) > 0) {
      start = mid + 1;
    } else {
      end = mid - 1;
    }
  }

  return undefined;
}

export function getRange(info) {
  const from = moment.tz(info.query.globalFilter.from, FULL_DATE_FORMAT, info.timezone);
  let to = moment.tz(info.query.globalFilter.to, FULL_DATE_FORMAT, info.timezone);
  to = info.groupBy === 'HOUR' ? to.subtract(1, 'hour') : to.subtract(1, 'day');
  return info.timeUnit !== undefined ? createDateRange(from, to, info.timeUnit) : undefined;
}

export function unwrapRows(rows = []) {
  const result = [];
  for (let i = 0; i < rows.length; i++) {
    result.push({ ...rows[i].data });
  }
  return result;
}

export function toCohortFormat(value, timezone) {
  const formattedDate = moment.tz(value, MS_FORMAT, timezone).format(DATE_DAILY_FORMAT);
  return formattedDate === DEFAULT_DATA ? value : formattedDate;
}
